module.exports = __webpack_public_path__ + "static/media/pixel-motion-1.76c774ea.png";